import { Type } from 'class-transformer';
import { IsNumber, Min } from 'class-validator';

export class PaginationOptionsDto {
  @Type(() => Number)
  @Min(0)
  @IsNumber()
  skip = 0;

  @Type(() => Number)
  @Min(1)
  @IsNumber()
  take = 100;
}
